import React from 'react';
import FormFieldLabel from './FormFieldLabel';
import FormTextField from './FormTextField';
import { Control } from 'react-hook-form';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    printBreakBefore: {
      pageBreakBefore: 'always',
      '@media print': {
        paddingTop: 32,
      },
    },
  }),
);

interface ProjectRoleFieldsProps {
  label?: string;
  baseName: string;
  control: Control<any>;
  labelStyle?: React.CSSProperties;
}

export function ProjectRoleFields(props: ProjectRoleFieldsProps) {
  const { label, baseName, control, labelStyle } = props;
  const classes = useStyles();

  const shouldPrintBreakBefore = ['qaQcReviewer', 'clientProjectManager'].includes(baseName);

  return (
    <>
      {label ? (
        <FormFieldLabel
          style={labelStyle}
          className={shouldPrintBreakBefore ? classes.printBreakBefore : undefined}
        >
          {label}
        </FormFieldLabel>
      ) : (
        <div />
      )}
      <div
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8 }}
        className={shouldPrintBreakBefore ? classes.printBreakBefore : undefined}
      >
        <FormTextField
          name={`${baseName}Name`}
          placeholder="Name"
          control={control}
          style={{ width: '100%' }}
        />
        <FormTextField
          name={`${baseName}Company`}
          placeholder="Company"
          control={control}
          style={{ width: '100%' }}
        />
        <FormTextField
          name={`${baseName}Email`}
          placeholder="Email"
          control={control}
          style={{ width: '100%' }}
        />
      </div>
    </>
  );
}
